<!--
  A loaded session is the only gate. Both the field-catalog and the read APIs require a real
  `helios-session-id`, and the read endpoints block until that session's load state is complete, so
  selecting an account in the account list is not enough — the account has to be loaded into a
  session. This is the same guard the classic Transactions panel uses.

  The `accountId` both APIs need comes from that session, never from the account-list selection:
  selecting a different account while a session is open must not re-key this panel, or the open
  session's columns and rows would be refetched for an account it is not showing.
-->
<hs-no-loaded-account [content]="workbenchContent"></hs-no-loaded-account>

<ng-template #workbenchContent>
  <div class="workbench-host" *ngIf="isEnfusionSession; else notApplicable">
    <div class="wb-region comparison" #comparison>
      <hs-cache-load-listener
        [content]="comparisonGridContent"
        [sessionCacheStatus]="comparisonCacheStatus"
        [sessionId]="currentSessionId"
        [accountIds]="currentAccountIds"
      ></hs-cache-load-listener>
      <ng-template #comparisonGridContent>
        <hs-workbench-grid [role]="comparisonRole"></hs-workbench-grid>
      </ng-template>
    </div>
    <hs-resize-handle
      [elem1]="comparison"
      [elem2]="base"
      [initialResizeHandleState]="state?.resizeHandleState"
      (resizeFinished)="onResizeFinished($event)"
    ></hs-resize-handle>
    <div class="wb-region base" #base>
      <hs-cache-load-listener
        [content]="baseGridContent"
        [sessionCacheStatus]="baseCacheStatus"
        [sessionId]="currentSessionId"
        [accountIds]="currentAccountIds"
      ></hs-cache-load-listener>
      <ng-template #baseGridContent>
        <hs-workbench-grid [role]="baseRole"></hs-workbench-grid>
      </ng-template>
    </div>
  </div>
</ng-template>

<!-- Not applicable for a CW session — Flex Transactions has no data for it. A CW session never
     focuses an account for this panel (transactions-2-panel.component.ts), so the Flex caches never
     get asked to load and each grid's hs-cache-load-listener would wait forever — this gate exists
     precisely so a CW session never reaches that wrapper at all. -->
<ng-template #notApplicable>
  <hs-panel-card header="Not Applicable">
    <p>Not applicable for current session — use the Transactions panel.</p>
  </hs-panel-card>
</ng-template>
